import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useOperationalRealtime } from './useOperationalRealtime';
import { isRealtimeClientEnabled } from './realtimeConfig';

/** Mount inside authenticated layout — wires websocket projections to RTK cache. */
const OperationalRealtimeSync: React.FC = () => {
  const { user } = useAuth();
  useOperationalRealtime(user?.id);

  if (!isRealtimeClientEnabled()) return null;
  return null;
};

export default OperationalRealtimeSync;
